import { NavLink } from 'react-router-dom';
import { truncate } from 'gossamer-unified';
import classes from './EventTile.module.css';
import { DisplayMarkdown } from '../ancillary/DisplayMarkdown';
import { EventExtendedViewRow } from 'cb-model';
import {
  formatEventDate,
  formatEventUrl,
  getCheapestPriceFormatted,
  getEventType,
  getTicketsLeftFromTicketData,
  TicketItemWithBookings,
} from './helpers';

export interface EventTileProps {
  eventUrl: string;
  eventType: string;
  title: string;
  image?: string;
  plainDescription: string;
  markdownDescription?: string;
  ticketsLeft?: number;
  startDate?: string; // pre-formatted
  cheapestPrice?: string; // pre-formatted
}

export const EventTile = (props: EventTileProps) => {
  const truncatedDescription = truncate(props.plainDescription, 156);
  const renderImage = () => (
    <div
      className="image"
      style={props.image ? { backgroundImage: `url(${props.image})` } : { backgroundColor: '#f1f5f9' }}
    >
      <div className="eventType">{getEventType(props.eventType)}</div>
      {props.cheapestPrice && <div className="cheapestPrice">{props.cheapestPrice}</div>}
    </div>
  );

  const renderBody = () => (
    <div className="main">
      <h2>{props.title}</h2>
      <div className={classes.description}>
        {props.markdownDescription ? (
          <DisplayMarkdown source={props.markdownDescription} />
        ) : (
          <p>{truncatedDescription}</p>
        )}
      </div>
      <div className="bottom">
        {typeof props.ticketsLeft === 'number' && (
          <div className="ticketsLeft">
            <img src="/assets/icons/user.svg" />
            <span>{props.ticketsLeft} tickets</span>
          </div>
        )}
        {props.startDate && <div className="startDate">{props.startDate}</div>}
      </div>
    </div>
  );
  return (
    <div className={classes.EventTile}>
      <NavLink to={props.eventUrl}>
        {renderImage()}
        {renderBody()}
      </NavLink>
    </div>
  );
};

interface EventTileFromRowProps {
  item: EventExtendedViewRow;
}

export const EventTileFromRow = ({ item }: EventTileFromRowProps) => (
  <EventTile
    key={item.id}
    eventUrl={formatEventUrl(item.title || '', item.id)}
    eventType={getEventType(item.type)}
    title={item.title}
    image={item.images}
    plainDescription={item.plain_description}
    markdownDescription={item.markdown_description || undefined}
    ticketsLeft={getTicketsLeftFromTicketData(item.ticket_data as unknown as TicketItemWithBookings[])}
    startDate={formatEventDate({ start: item.start_at, end: item.end_at })}
    cheapestPrice={getCheapestPriceFormatted(item.ticket_data as unknown as TicketItemWithBookings[])}
  />
);
